import {
  ArchiveBoxIcon,
  BookOpenIcon,
  BriefcaseIcon,
  BuildingOfficeIcon,
  BuildingStorefrontIcon,
  CalendarDaysIcon,
  ChartBarIcon,
  ChartBarSquareIcon,
  ChartPieIcon,
  ChatBubbleBottomCenterTextIcon,
  ChatBubbleLeftRightIcon,
  CircleStackIcon,
  ClipboardDocumentListIcon,
  ClockIcon,
  Cog6ToothIcon,
  CommandLineIcon,
  ComputerDesktopIcon,
  CpuChipIcon,
  CubeIcon,
  CurrencyDollarIcon,
  DocumentCheckIcon,
  DocumentTextIcon,
  EnvelopeIcon,
  ExclamationTriangleIcon,
  EyeIcon,
  FaceSmileIcon,
  FlagIcon,
  FolderIcon,
  GlobeAltIcon,
  HeartIcon,
  HomeIcon,
  IdentificationIcon,
  InboxArrowDownIcon,
  KeyIcon,
  LockClosedIcon,
  PresentationChartLineIcon,
  PuzzlePieceIcon,
  QueueListIcon,
  RectangleGroupIcon,
  RectangleStackIcon,
  RocketLaunchIcon,
  ServerStackIcon,
  ShareIcon,
  ShieldCheckIcon,
  SignalIcon,
  SparklesIcon,
  Squares2X2Icon,
  PencilSquareIcon,
  PaperAirplaneIcon,
  TicketIcon,
  UserPlusIcon,
  UsersIcon,
  UserGroupIcon,
} from '@heroicons/react/24/outline';
import type { SidebarIcon } from './sidebarMenuTypes';
import HeadphonesIcon from './HeadphonesIcon';

const MODULE_ICONS: Record<string, SidebarIcon> = {
  'core.companies': BuildingOfficeIcon,
  'core.contacts': IdentificationIcon,
  'access-control.users': UsersIcon,
  'access-control.teams': RectangleGroupIcon,
  'access-control.roles': ShieldCheckIcon,
  'access-control.permission-groups': KeyIcon,
  'people.job-positions': BriefcaseIcon,
  'people.competencies': ChartBarIcon,
  'people.evaluations': ChartBarSquareIcon,
  'people.notes': PencilSquareIcon,
  'people.my-team': UserGroupIcon,
  'access-control.modules': Squares2X2Icon,
  storage: CircleStackIcon,
  'sales.opportunities': ChartBarSquareIcon,
  'sales.prospects': UserPlusIcon,
  'commercial.contracts': DocumentTextIcon,
  'commercial.projects': FolderIcon,
  'sales.products': CubeIcon,
  'products.workspace': CubeIcon,
  'sales.capabilities': PuzzlePieceIcon,
  'sales.market-segments': GlobeAltIcon,
  'sales.product-resources': ArchiveBoxIcon,
  'sales.buyer-personas': FaceSmileIcon,
  'sales.pricing': CurrencyDollarIcon,
  'sales.gtm-analytics': ChartPieIcon,
  'sales.campaign-tags': FlagIcon,
  'operations.calendars': CalendarDaysIcon,
  'strategic-planning': ClipboardDocumentListIcon,
  monitor: ComputerDesktopIcon,
  monitoring: PresentationChartLineIcon,
  'customer-success.desk': HeadphonesIcon,
  'customer-success.tickets': TicketIcon,
  'customer-success.service-catalog': QueueListIcon,
  'customer-success.analytics': ChartBarIcon,
  'customer-success.channels': ChatBubbleLeftRightIcon,
  'customer-success.inbound': InboxArrowDownIcon,
  'customer-success.problems': ExclamationTriangleIcon,
  'customer-success.engagement': ChatBubbleBottomCenterTextIcon,
  'customer-success.health': HeartIcon,
  'customer-success.settings': Cog6ToothIcon,
  'settings.system': Cog6ToothIcon,
  'settings.email-templates': EnvelopeIcon,
  'settings.email-queue': PaperAirplaneIcon,
  'settings.decision-engine': ShareIcon,
  'technology.overview': ChartPieIcon,
  'technology.applications': CommandLineIcon,
  'technology.portfolio': RectangleGroupIcon,
  'technology.infrastructure': ServerStackIcon,
  'technology.integrations': PuzzlePieceIcon,
  'technology.secrets': LockClosedIcon,
  'technology.certificates': DocumentCheckIcon,
  'technology.keys': KeyIcon,
  'technology.ai-models': CpuChipIcon,
  'technology.ai-prompts': ChatBubbleBottomCenterTextIcon,
  'technology.ai-benchmarks': ChartBarIcon,
  'technology.ai-costs': CurrencyDollarIcon,
  manual: BookOpenIcon,
  'manual.expired': ArchiveBoxIcon,
  'manual.views': EyeIcon,
  'technology.documentation': BookOpenIcon,
  'technology.documentation-expired': ArchiveBoxIcon,
  'technology.documentation-views': EyeIcon,
  'technology.deployments': RocketLaunchIcon,
  'technology.deployments.documentation': BookOpenIcon,
  'technology.catalog': QueueListIcon,
  'technology.backups': ArchiveBoxIcon,
  'technology.monitoring': SignalIcon,
  'reports.access': ClockIcon,
};

const MODULE_LABELS: Record<string, string> = {
  'operations.calendars': 'Calendário',
  monitor: 'Monitor',
  monitoring: 'Monitoramento',
  'reports.access': 'Acessos',
  'strategic-planning': 'Planejamento estratégico',
  'access-control.roles': 'Perfis',
  'access-control.permission-groups': 'Grupos',
  'people.job-positions': 'Cargos',
  'people.competencies': 'Indicadores',
  'people.evaluations': 'Avaliações',
  'core.companies': 'Clientes',
  'commercial.projects': 'Projetos',
  'people.notes': 'Anotações',
  'people.my-team': 'Minha Equipe',
  'sales.campaign-tags': 'Campanhas',
  'sales.capabilities': 'Capabilities',
  'sales.market-segments': 'Segmentos',
  'sales.product-resources': 'Recursos',
  'sales.buyer-personas': 'Personas',
  'sales.pricing': 'Precificação',
  'sales.gtm-analytics': 'Analytics GTM',
  'sales.opportunities': 'Pipeline',
  'products.workspace': 'Produtos',
  'dashboard.commercial': 'Visão geral',
  'dashboard.operations': 'Visão geral',
  'dashboard.marketing': 'Visão geral',
  'dashboard.people': 'Visão geral',
  'dashboard.customer-success': 'Visão geral',
  'dashboard.relationship': 'Visão geral',
  'customer-success.desk': 'Atendimento',
  'customer-success.service-catalog': 'Catálogo de serviços',
  'customer-success.analytics': 'Analytics',
  'customer-success.channels': 'Canais',
  'customer-success.inbound': 'Inbound',
  'customer-success.problems': 'Problemas',
  'customer-success.engagement': 'Respostas prontas',
  'customer-success.health': 'Saúde da Conta',
  'customer-success.settings': 'Configurações',
  'access-control.modules': 'Módulos',
  storage: 'Armazenamento',
  'settings.system': 'Configurações',
  'settings.email-templates': 'Templates de e-mail',
  'settings.email-queue': 'Fila de e-mails',
  'settings.decision-engine': 'Motor de decisão',
  'technology.overview': 'Visão geral',
  'technology.applications': 'Aplicações',
  'technology.portfolio': 'Sistemas',
  'technology.infrastructure': 'Infraestrutura',
  'technology.integrations': 'Integrações',
  'technology.secrets': 'Cofre',
  'technology.certificates': 'Certificados',
  'technology.keys': 'Chaves',
  'technology.ai-models': 'Modelos',
  'technology.ai-prompts': 'Prompts',
  'technology.ai-benchmarks': 'Benchmarks',
  'technology.ai-costs': 'Custos',
  manual: 'Manual',
  'manual.expired': 'Documentos expirados',
  'manual.views': 'Visualizações',
  'technology.documentation': 'Documentação',
  'technology.documentation-expired': 'Documentos expirados',
  'technology.documentation-views': 'Visualizações',
  'technology.deployments': 'Deploys',
  'technology.deployments.documentation': 'Releases',
  'technology.catalog': 'Inventário',
  'technology.backups': 'Backups',
  'technology.monitoring': 'Monitoramento',
};

/** Ícone exclusivo do item Empresa em Conta (não reutiliza ícones de módulos). */
export const ACCOUNT_COMPANY_ICON: SidebarIcon = BuildingStorefrontIcon;

export const TECHNOLOGY_SECURITY_GROUP_ICON: SidebarIcon = LockClosedIcon;
export const TECHNOLOGY_AI_GROUP_ICON: SidebarIcon = SparklesIcon;
export const TECHNOLOGY_GOVERNANCE_GROUP_ICON: SidebarIcon = ShieldCheckIcon;

const DASHBOARD_AREA_MODULE_CODES = new Set([
  'dashboard.commercial',
  'dashboard.operations',
  'dashboard.marketing',
  'dashboard.people',
  'dashboard.customer-success',
  'dashboard.relationship',
]);

export function resolveModuleMenuIcon(moduleCode: string): SidebarIcon {
  if (DASHBOARD_AREA_MODULE_CODES.has(moduleCode)) {
    return HomeIcon;
  }

  return MODULE_ICONS[moduleCode] ?? RectangleStackIcon;
}

export function resolveModuleMenuLabel(moduleCode: string, fallbackName: string): string {
  return MODULE_LABELS[moduleCode] ?? fallbackName;
}
